import React from "react";
import styled from "styled-components";

const HorStyle = styled.div`
    width: 0;
    height: ${props => props.$size};
    flex-shrink: 0;
`;

const VerStyle = styled.div`
    width: ${props => props.$size};
    height: 0;
`;

export const Spacer = React.memo(props => {

    const { variant, size } = props;
    const multiplier = size === "large" ? 3 : (size === "medium" ? 2 : 1);
    const cssSize = ((variant === "horizontal" ? 15 : 10) * multiplier) + "px";

    return (
        <>
            {variant === "vertical" &&
                <VerStyle $size={cssSize} />
            }
            {variant === "horizontal" &&
                <HorStyle $size={cssSize} />
            }
        </>
    );
});